import { createApp } from 'vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'mdb-vue-ui-kit/css/mdb.min.css';

import './assets/main.css';
import App from './App.vue';
import { CONFIG } from '@/config';
import type { Site } from '@datadog/browser-rum';
import { createDatadogPlugin } from '@/plugins/datadog';
import router from './router/index';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

/* add icons to the library */
library.add(faPhoneAlt);

const app = createApp(App);

app.use(
  createDatadogPlugin({
    applicationId: CONFIG.ddRumApplicationId,
    clientToken: CONFIG.ddRumClientToken,
    site: CONFIG.ddSite as Site,
    env: CONFIG.ddEnv,
    service: CONFIG.ddService,
    sessionSampleRate: CONFIG.ddSessionSampleRate,
    sessionReplaySampleRate: CONFIG.ddSessionReplaySampleRate,
    allowedTracingUrls: CONFIG.ddAllowedTracingUrls,
    router,
    // Optional kill switch (port of your isDatadogLoggerEnabled)
    isEnabled: () => {
      return CONFIG.ddRumApplicationId !== '' && CONFIG.ddRumClientToken !== '';
    },
  })
);

app.use(router);

app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');
